export type Route =
  | { name: 'book'; slug: string }
  | { name: 'manage'; token: string }
  | { name: 'unknown' }

/**
 * Two public routes, read straight from the URL. No router dependency — the
 * booking app is deliberately a single small bundle.
 *
 *   /book/:slug                       the practice's booking page
 *   /appointments/manage?token=…      the link in a confirmation email
 */
export function readRoute(pathname: string, search: string): Route {
  const segments = pathname.split('/').filter(Boolean)

  if (segments[0] === 'book' && segments[1]) {
    return { name: 'book', slug: decodeURIComponent(segments[1]) }
  }

  if (segments[0] === 'appointments' && segments[1] === 'manage') {
    const token = new URLSearchParams(search).get('token')?.trim()
    if (token) {
      return { name: 'manage', token }
    }
  }

  return { name: 'unknown' }
}
